import { call, put, select } from 'redux-saga/effects';
import { PoiAPI } from '../apis';
import { POI_ACTION_TYPES } from '../actionTypes';

export function* getPoiInformation() {
  try {
    const reduxStore = yield select(state => state.poi);
    const place_id = reduxStore.selected_poi.id;

    const response = yield call(PoiAPI.getByPlaceId, place_id);
    const payload = response || {};
    yield put({
      type: POI_ACTION_TYPES.GET_POI_INFORMATION.SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: POI_ACTION_TYPES.GET_POI_INFORMATION.ERROR,
      error,
    });
  }
}

export function* savePoiFromWS(action) {
  yield put({
    type: POI_ACTION_TYPES.POI_FROM_WS.SUCCESS,
    payload: action.payload,
  });
}

export function* saveSelectedPoi(action) {
  yield put({
    type: POI_ACTION_TYPES.POI_SELECTED.SUCCESS,
    payload: action.payload,
  });
}

const customFilter = (filters, list) =>
  list.filter(item => {
    if (item.poi) {
      const {
        poi: { price_level, rating, open_now },
      } = item;
      return (
        (price_level === filters.price || filters.price === '*') &&
        (Math.round(rating) === filters.rating || filters.rating === '*') &&
        open_now === filters.openNow
      );
    }
    return [];
  });

export function* filterPoiList() {
  const reduxStore = yield select(state => state.poi);
  const filters = reduxStore.filter_criteria_list;
  let filteredList = reduxStore.poi_list;
  filteredList = filters ? customFilter(filters, filteredList) : filteredList;
  yield put({
    type: POI_ACTION_TYPES.FILTER.SAVE_LIST,
    payload: {
      filteredList,
    },
  });
}
